import { BehaviorSubject, Observable } from 'rxjs';

interface IToast {
  message: string;
  status: string;
  count: number;
  html: boolean;
}

let toasts: IToast[] = [];
let sequencer: number = 0;

const Toast$ = new BehaviorSubject(toasts);

function show(message: string = '', status: 'success' | 'warn' | 'error' | '' = '', html: boolean = false, time: number = 5000): void {
  sequencer++;
  const size = toasts.push({ message, status, count: sequencer, html});
  Toast$.next(toasts);

  setTimeout(() => {
    removeLast();
  }, time);
}

function removeLast(): void {
  toasts.splice(0, 1);
  Toast$.next(toasts);
}

function removeAll(): void {
  toasts = [];
  Toast$.next(toasts);
}

function hide(seq: number): void {
  const pos = toasts.findIndex((i) => i.count === seq);
  toasts.splice(pos, 1);
  Toast$.next(toasts);
}

function get(): Observable<any> {
  return Toast$;
}

export { show, removeLast, removeAll, hide, get };
